import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-236bc3c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal_bg" }
const _hoisted_2 = { class: "modal_main" }
const _hoisted_3 = { class: "modal_header" }
const _hoisted_4 = { class: "modal_header_label" }
const _hoisted_5 = { class: "modal_contents" }
const _hoisted_6 = { class: "modal_contents_inner" }
const _hoisted_7 = { class: "modal_footer" }
const _hoisted_8 = { class: "modal_footer_inner" }
const _hoisted_9 = { class: "modal_footer_button" }
const _hoisted_10 = { class: "modal_footer_button_prev" }
const _hoisted_11 = { class: "modal_footer_button_next" }

import BaseButton from './BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
  title: {
    type: String,
    default: '',
  },
  leftBtnText: {
    type: String,
    default: 'クリア',
  },
  leftBtnDisabled: {
    type: Boolean,
    default: false,
  },
  rightBtnText: {
    type: String,
    default: '決定する',
  },
  rightBtnDisabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ["leftBtnClick", "rightBtnClick", "close"],
  setup(__props, { emit }: { emit: ({
  (e: 'leftBtnClick'): true;
  (e: 'rightBtnClick'): true;
  (e: 'close'): true;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const close = () => {
  emit('close');
};

const handleLeftBtnClick = () => {
  emit('leftBtnClick');
};

const handleRightBtnClick = () => {
  emit('rightBtnClick');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(props.title), 1),
        _createElementVNode("span", {
          class: "modal_header_close",
          onClick: close
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "footer", {}, () => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(BaseButton, {
                  theme: "tertiary",
                  size: "s",
                  disabled: props.leftBtnDisabled,
                  onClick: handleLeftBtnClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.leftBtnText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(BaseButton, {
                  size: "s",
                  disabled: props.rightBtnDisabled,
                  onClick: handleRightBtnClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(props.rightBtnText), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})